import { AnimatePresence } from "framer-motion";
import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { reviewService } from "../../Services";

import { utils } from "../../Helpers/utils";
import {
  EditorInput,
  StarRating,
  assignToListIconRed,
  assignToListIcon,
} from "../../Components";
import { InfluencerRating } from "../../Components";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  ContentState,
} from "draft-js";
const initForm = {
  rating: "",
  offer_id: "",
  comment: "",
};
export default function CreateReview({
  isloaded,
  user,
  offerDetails,
  readOnly,
  review,
  toastList,
  setToastList,
  offerId,
  gotoOffer,
}) {
  const [error, setError] = useState(false);
  const [form, setForm] = useState(
    review
      ? {
          rating: review.rating,
          offer_id: review.offer_id,
          comment: review.comment,
        }
      : initForm
  );
  console.log("🚀 ~ CreateReview ~ form:", form);
  const [isReadOnly, setIsReadOnly] = useState(readOnly);
  const [isReviewSaved, setIsReviewSaved] = useState(false);
  let contentState = "";
  let descHasValidJson = utils.testJSON(form.comment);
  if (descHasValidJson === true) {
    contentState = convertFromRaw(
      form.comment
        ? descHasValidJson === true
          ? JSON.parse(form.comment)
          : JSON.parse(
              `{"blocks":[{"key":"cdfv2","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":5,"length":19,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`
            )
        : JSON.parse(
            `{"blocks":[{"key":"cdfv2","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":5,"length":19,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`
          )
    );
  } else {
    if (form.comment !== null) {
      contentState = ContentState.createFromText(form.comment);
    } else {
      contentState = convertFromRaw(
        JSON.parse(
          `{"blocks":[{"key":"cdfv2","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":5,"length":19,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}`
        )
      );
    }
  }
  const [editorState, setEditorState] = useState(
    EditorState.createWithContent(contentState)
  );
  const handleRating = (rating) => {
    //console.log('User rated:', rating);
    updateForm({ rating: rating });
    // You can now send this to your API or state
  };
  const updateTextDescription = async (state) => {
    await setEditorState(state);
    const rawContentState = convertToRaw(state.getCurrentContent());
  };
  const setDesc = (key) => (event) => {
    updateForm({ ["comment"]: JSON.stringify(event) });
  };
  const updateForm = (data) => {
    setForm({ ...form, ...data });
  };
  const setInput = (key) => (event) =>
    updateForm({ [key]: event.target.value });
  const validateReview = () => {
    let isError = false;
    if (form.rating === "") {
      isError = true;
    }
    if (isError == true) {
      addToast({
        error: true,
        msg: "Please select your rating",
        id: `${Date.now()}-${toastList.length}`,
      });
    } else {
      saveReview();
    }
  };
  useEffect(() => {
    setIsReadOnly(readOnly);
  }, [isloaded, review]);

  const saveReview = async () => {
    try {
      let param = {
        offer_id: offerId,
        rating: form.rating,
        comment: form.comment,
      };
      const res = await reviewService.addReview(param);
      if (res.success === true) {
        setIsReadOnly(true);
        setIsReviewSaved(!isReviewSaved);
        addToast({
          error: false,
          msg: res.message,
          id: `${Date.now()}-${toastList.length}`,
        });
      }
      // setIsLoaded(true);
    } catch (err) {
      //if (err.apiResponseStatus != 409) {
      addToast({
        error: true,
        msg: err.message,
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  };
  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };
  return (
    <>
      {isloaded && (
        <>
          <div className="">
            {isloaded && (
              <div className="form reviewform">
                <div className="formCampaigns__detail">
                  <div className="formCampaigns__detail-desc">
                    <div className="input__outer">
                      <label>Select your rating</label>
                      <StarRating
                        onRate={handleRating}
                        initrating={form.rating}
                        readonly={isReadOnly}
                      />
                    </div>
                  </div>
                </div>
                <div className="formCampaigns__detail">
                  <div className={"formCampaigns__detail-desc descnopadding"}>
                    {isReadOnly != true ? (
                      <EditorInput
                        value={
                          form.comment === ""
                            ? form.comment
                            : utils.testJSON(form.comment) === true
                            ? JSON.parse(form.comment).blocks
                            : ""
                        }
                        editorState={editorState}
                        label="Write your review"
                        onEditorStateChange={updateTextDescription}
                        error={error}
                        errorText="Please enter review"
                        onChange={setDesc(
                          convertToRaw(editorState.getCurrentContent())
                        )}
                        readOnly={isReadOnly}
                      />
                    ) : (
                      <>
                        <div className="input__outer descnopadding">
                          <label>{"Your review"}</label>
                          <Editor
                            editorState={editorState}
                            toolbarHidden={true}
                            readOnly={true}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
            {isReadOnly != true ? (
              <div className="campaignsCreate__btns">
                <div className="campaignsCreate__btns-row">
                  <button className="button secondary" onClick={gotoOffer}>
                    Cancel
                  </button>
                </div>
                <button className="button primary" onClick={validateReview}>
                  Submit the Review
                </button>
              </div>
            ) : (
              <div className="campaignsCreate__btns">
                <div className="campaignsCreate__btns-row">
                  <button className="button secondary" onClick={gotoOffer}>
                    Back
                  </button>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}
